import { render, staticRenderFns } from "./DocDownload.vue?vue&type=template&id=a0fe0dc8&scoped=true&"
import script from "./DocDownload.vue?vue&type=script&lang=js&"
export * from "./DocDownload.vue?vue&type=script&lang=js&"
import style0 from "./DocDownload.vue?vue&type=style&index=0&id=a0fe0dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fe0dc8",
  null
  
)

export default component.exports